"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TableCell = _interopRequireDefault(require("./TableCell.style"));
var _excluded = ["children", "highlight", "maxWidth", "type", "mappedStatus"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var TableCell = function TableCell(_ref) {
  var children = _ref.children,
    highlight = _ref.highlight,
    maxWidth = _ref.maxWidth,
    type = _ref.type,
    mappedStatus = _ref.mappedStatus,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_TableCell["default"], _extends({
    highlight: highlight,
    type: type,
    mappedStatus: mappedStatus,
    maxWidth: maxWidth
  }, otherProps), type === 'status' && /*#__PURE__*/_react["default"].createElement("span", {
    className: "status-dot"
  }), children);
};
TableCell.propTypes = {
  /** The alignment of the table text */
  align: _propTypes["default"].oneOf(['right', 'left', 'center']),
  /**
   * The content of the table cell, normally a node or a string.
   * */
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].string]),
  /**
   * Flag to indicate wheather the currenct cell should be highlighted.
   * */
  highlight: _propTypes["default"].bool,
  /**
   * Width in pixels if a certain column should have a maximum width
   * */
  maxWidth: _propTypes["default"].number,
  type: _propTypes["default"].oneOf(['date', 'status', 'checkbox', 'feedbackScore', '']),
  mappedStatus: _propTypes["default"].shape({})
};
TableCell.defaultProps = {
  align: 'left',
  children: '',
  highlight: false,
  maxWidth: undefined,
  type: null,
  mappedStatus: null
};
TableCell.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TableCell",
  "props": {
    "align": {
      "defaultValue": {
        "value": "'left'",
        "computed": false
      },
      "description": "The alignment of the table text",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'right'",
          "computed": false
        }, {
          "value": "'left'",
          "computed": false
        }, {
          "value": "'center'",
          "computed": false
        }]
      },
      "required": false
    },
    "children": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "The content of the table cell, normally a node or a string.",
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "string"
        }]
      },
      "required": false
    },
    "highlight": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Flag to indicate wheather the currenct cell should be highlighted.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "maxWidth": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Width in pixels if a certain column should have a maximum width",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "type": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'date'",
          "computed": false
        }, {
          "value": "'status'",
          "computed": false
        }, {
          "value": "'checkbox'",
          "computed": false
        }, {
          "value": "'feedbackScore'",
          "computed": false
        }, {
          "value": "''",
          "computed": false
        }]
      },
      "required": false
    },
    "mappedStatus": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    }
  }
};
var _default = /*#__PURE__*/(0, _react.memo)(TableCell);
exports["default"] = _default;